import { Box } from "@mui/material"
import { VisibilityOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import TestTemplateProductsDialog from "../TestTemplateProductsDialog"

import { Button } from "@/components/common/Button"
import Chip from "@/components/common/Chip/Chip"
import type { TestTemplate } from "@/graphql/codegen/graphql"

interface TestTemplateProductsCellProps {
  testTemplate: TestTemplate
}

const TestTemplateProductsCell: FC<TestTemplateProductsCellProps> = ({ testTemplate }) => {
  const [isProductsDialogOpen, setIsProductsDialogOpen] = useState(false)
  const productsCount = testTemplate.associatedTestTemplatesCount ?? 0

  return (
    <>
      <Box className='flex items-center gap-x-4'>
        <Button
          variant='primary'
          appearance='text'
          size='small'
          startIcon={<VisibilityOutlined />}
          onClick={() => setIsProductsDialogOpen(true)}
          disabled={!productsCount}
        >
          View All
        </Button>
        <Chip color='primary' label={productsCount} />
      </Box>
      {isProductsDialogOpen && (
        <TestTemplateProductsDialog testTemplate={testTemplate} onClose={() => setIsProductsDialogOpen(false)} />
      )}
    </>
  )
}

export default TestTemplateProductsCell
